import { 
  AnalyticsActionTypes, 
  SET_ANALYTICS_DATA, 
  SET_USAGE_METRICS_DATA,
  IAnalyticsDataItem,
  IUsageMetricsDataItem 
} from './types';

export interface IAnalyticsState {
  analyticsData: IAnalyticsDataItem[];
  usageMetricsData: IUsageMetricsDataItem[];
}

const initialState: IAnalyticsState = {
  analyticsData: [],
  usageMetricsData: [],
};

export const analyticsReducer = (state = initialState, action: AnalyticsActionTypes): IAnalyticsState => {
  switch (action.type) {
    case SET_ANALYTICS_DATA:
      return {
        ...state,
        analyticsData: action.payload,
      };
    case SET_USAGE_METRICS_DATA:
      return {
        ...state,
        usageMetricsData: action.payload,
      };
    default:
      return state;
  }
};
